import { useCallback, useRef, useState } from "react";

import { useSpring } from "@react-spring/web";
import { useObjectMemo } from "byzantine";

import { useCurrentUser } from "../../../../../components/contexts/CurrentUserContext";
import {
  guideActions,
  useOnboardingGuideStorage,
} from "../../../guides/storage";

export const useDismissAnimation = () => {
  const { currentUser } = useCurrentUser();
  const userId = currentUser?.id?.toString() || "";

  const [_, setGuideState] = useOnboardingGuideStorage(userId);
  const [dismissingUuid, setDismissingUuid] = useState<string | null>(null);
  const dismissingUuidRef = useRef<string | null>(null);

  const dismissSpring = useSpring({
    opacity: dismissingUuid ? 0 : 1,
    transform: dismissingUuid ? "translateX(-100%)" : "translateX(0%)",
    config: { tension: 220, friction: 24 },
    onRest: () => {
      if (dismissingUuidRef.current) {
        const uuid = dismissingUuidRef.current;
        dismissingUuidRef.current = null;
        setDismissingUuid(null);
        setGuideState((prev) => guideActions.dismissPrompt(prev, uuid));
      }
    },
  });

  const dismissPrompt = useCallback((promptUuid: string) => {
    dismissingUuidRef.current = promptUuid;
    setDismissingUuid(promptUuid);
  }, []);

  return useObjectMemo({ dismissingUuid, dismissSpring, dismissPrompt });
};
